import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
    // TODO: send to Sentry or similar when wired up
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          background: '#f8fafc',
          textAlign: 'center',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '3rem 2rem',
            maxWidth: '480px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          }}>
            <h1 style={{ fontSize: '1.5rem', color: '#1E3A70', marginBottom: '0.5rem' }}>
              Something went wrong
            </h1>
            <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              An unexpected error occurred. Please try refreshing the page.
            </p>
            {process.env.NODE_ENV !== 'production' && this.state.error && (
              <pre style={{
                background: '#f1f5f9',
                padding: '1rem',
                borderRadius: '8px',
                fontSize: '0.75rem',
                color: '#ef4444',
                textAlign: 'left',
                overflow: 'auto',
                maxHeight: '200px',
                marginBottom: '1.5rem',
              }}>
                {this.state.error.message}
              </pre>
            )}
            <button
              onClick={this.handleReload}
              style={{
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.75rem 2rem',
                fontSize: '1rem',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Go to Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
